import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./OuterSectionContainer.module.css";
import AddIcon from "@mui/icons-material/Add";
import ButtonMUI from "@mui/material/Button";
import AddSectionLectureForm from "./AddSectionLectureForm";
import { useDispatch } from "react-redux";
import { deleteSection } from "../../../redux/actions/courses";
import UpdateLectureComponent from "./UpdateLectureComponent";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import ConfirmAddContentModal from "../Modals/ConfirmAddContentModal";
import Modal from "../../../components/commons/Modal";

const OuterSectionContainer = (props) => {
  const { t } = useTranslation();
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const canEdit = props.canEdit === undefined ? true : Boolean(props.canEdit);

  const [showBar, setShowBar] = useState(false);
  const [showAddLectureForm, setShowAddLectureForm] = useState(false);
  const [showQuizModal, setShowQuizModal] = useState(false);
  const styleButtonMUI = {
    display: "flex",
    alignItems: "center",
    borderRadius: "10px",
    backgroundColor: "#F33070",
    borderColor: "#F33070",
    color: "#fff",
    textTransform: "none",
    // boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
    marginRight: "auto",
    "&:hover": {
      backgroundColor: "#fff",
      borderColor: "#F33070",
      color: "#F33070",
      boxShadow: "rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;",
    },
    "&.Mui-disabled": {
      backgroundColor: "#f6f6f6",
      color: "#959595",
      borderColor: "#f6f6f6",
    },
    "@media (max-width: 500px)": {
      height: "25px",
      padding: "6.756px 6.647px 8px 10px",
    },
  };

  const styleAddIcon = {
    "@media (max-width: 500px)": {
      width: "13px",
      height: "13px",
    },
  };

  const handleSectionEdit = () => {
    console.log("Editing section");
    props.onEdit(props.sectionID, props.title);
  };

  const handleNavigateToTemplatePage = (type) => {
    if (!canEdit) {
      dispatch(handleErrorMessage(t("courseMonetisation.notAllowed")));
      return;
    }
    if (type === "later") {
      history.push(`/quiz/create/${id}`, { sectionId: props?.sectionID });
    } else {
      history.push(`/template/create/${id}`, { sectionId: props?.sectionID });
    }
  };

  return (
    <div className={styles.main}>
      <div className={styles.section_header}>
        <div className={styles.section_title}>
          {`${t("common.section")} ${props.index + 1}: `}
          <span>{props.title}</span>
        </div>
        <div className={props.isEditing || !canEdit ? styles.icons_disabled : styles.icons}>
          <img
            src={`/Image/lecturePlan/${
              props.isEditing ? "Edit-grey" : "Edit"
            }.svg`}
            onClick={props.isEditing ? null : handleSectionEdit}
          />
          <img
            src={`/Image/lecturePlan/${
              props.isEditing ? "delete-bin-grey" : "delete-bin"
            }.svg`}
            onClick={
              props.isEditing
                ? null
                : () => dispatch(deleteSection(props.sectionID))
            }
          />
        </div>
      </div>

      {props.children}

      {!showBar ? (
        <ButtonMUI
          variant="outlined"
          startIcon={<AddIcon sx={styleAddIcon} />}
          disableRipple
          disabled={showAddLectureForm || props.isEditing || !canEdit}
          onClick={() => setShowBar(true)}
          // onClick={() => console.log("clickedBar", showBar)}
          sx={styleButtonMUI}
        >
          <span className={styles.btn_label}>
            {t("courseMonetisation.curriculumItem")}
          </span>
        </ButtonMUI>
      ) : (
        <div className={styles.selection_bar}>
          <div
            className={styles.option}
            onClick={() => {
              if (!canEdit) return;
              setShowAddLectureForm(true);
              setShowBar(false);
            }}
            title={!canEdit ? t("courseMonetisation.notAllowed") : ""}
            style={{ cursor: !canEdit ? "default" : "pointer" }}
          >
            <img src="/Image/plus.svg" />
            <span>{t("common.lecture")}</span>
          </div>
          <div
            className={`${styles.option} ${styles.option_quiz}`}
            onClick={() => {
              if (!canEdit) return;
              setShowQuizModal(true);
            }}
            title={!canEdit ? t("courseMonetisation.notAllowed") : ""}
            style={{ cursor: !canEdit ? "default" : "pointer" }}
          >
            <img src="/Image/plus.svg" />
            <span>{t("quiz.quiz")}</span>
          </div>
          {/* <div className={styles.option}>
            <img src="/Image/plus.svg" />
            <span>{t("assignment.assignment")}</span>
          </div> */}
        </div>
      )}

      {showAddLectureForm && canEdit && (
        <AddSectionLectureForm
          isSection={false}
          onCancel={() => setShowAddLectureForm(false)}
          sectionID={props.sectionID}
          lectureID={props.lectureEditData?.id}
          isEditing={props.isEditing}
          title={props.lectureEditData?.title}
          lecture={props.lectureEditData}
          onSuccessfulUpdate={() => {
            setShowAddLectureForm(false); // this hides the AddSectionLectureForm
            props.onCancelLectureUpdate(); // this reset is the props.isEditing and props.lectureEditData data state
          }}
        />
      )}

      {/* {console.log("isEqual", {props.sectionID, props.lectureEditData.sectionID})} */}

      {props.sectionID === props.lectureEditData?.sectionID &&
        props.showUpdateLectureForm && (
          <UpdateLectureComponent
            lecture={props.lectureEditData}
            onCancel={props.onCancelLectureUpdate}
            onCrossingContentLink={() => {
              setShowAddLectureForm(true);
              props.onLectureContentUpdate();
            }}
          />
        )}

      {showQuizModal && !canEdit && (
        <Modal
          card={
            <ConfirmAddContentModal
              isQuiz={true}
              onYes={() => {
                handleNavigateToTemplatePage("next");
              }}
              onLater={() => {
                handleNavigateToTemplatePage("later");
              }}
            />
          }
          onOutsideClick={() => setShowQuizModal(false)}
        />
      )}
    </div>
  );
};

export default OuterSectionContainer;
